import { IPortalContextValue } from './PortalContext';

let portalContext: IPortalContextValue | null = null;

export function setPortalContext(context: IPortalContextValue) {
  portalContext = context;
}

export function teleportToGate(gateName: string, element: JSX.Element) {
  portalContext?.teleport(gateName, element);
}

export function removeGate(gateName: string) {
  portalContext?.removeGate(gateName);
}

export function getPortalContext() {
  return portalContext;
}
